export default {
    payersNameContainer: {
        display: "inline-flex",
        flex: "1 1 0%",
        width: "66%",
    },
    payersMiddleNameContainer: {
        marginLeft: '3%',
         marginRight: '3%', 
         width: '100%',
    },
    payerFieldsContainer: {
        display: 'flex',
        flex: '1 1 0%',
         width: '66%',
    },
    payerBatch1Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '95%',
    },
    payerBatch2Container: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%',
        marginLeft: '3%',
    },
}